var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"topics-list__item",on:{"click":function($event){return _vm.$emit('click', _vm.topicInfo)}}},[_c('h3',[_vm._v(_vm._s(_vm.topicInfo.title))]),_c('span',[_vm._v(_vm._s(_vm.topicInfo.create_at))])])}
var staticRenderFns = []

export { render, staticRenderFns }